import React from 'react';

import {ReactComponent as Parrot} from '../../assets/images/Parrot_sleeping_2.svg';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null, buttonText: 'Copy Error' };
    }

    changeButtonText = (text) => {
        this.setState({
            buttonText: text
        });
    }

    copyError = () => {
        // Get the text field
        var copyText = document.getElementById("error-log");

        // Select the text field
        copyText.select();
        copyText.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        navigator.clipboard.writeText(copyText.value);

        this.changeButtonText('Copied to clipboard');
        

        setTimeout( function() {
            this.changeButtonText('Copy Error');
        }.bind(this), 1000 )
    }
    
    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        // You can also log error messages to an error reporting service here
    }
    
    render() {
      if (this.state.errorInfo) {
        // Error path
        return (
          <div className="error-screen">
          <div className="error-screen__container">
            {/* <img src={Logo} alt="golingo Parrot" title="golingo Parrot" /> */}
            <Parrot />
            <h2 className="error-screen__title">Oh no!</h2>
            <p>
              It looks like something went wrong! Please report this error, along with the below errors, to our team either via the chat widget or email <a href="mailto:help@golingo.co.uk">help@golingo.co.uk</a> so we can get you back to Pollywood as soon as possible!
            </p>
            <div className="error-container">
                <details  className="error-report" style={{ whiteSpace: 'pre-wrap' }}>
                    <summary>{this.state.error && this.state.error.toString()}</summary>
                    <button className='button button--white' onClick={this.copyError}>{this.state.buttonText}</button>
                    <textarea id="error-log">
                        {this.state.error && this.state.error.toString() + this.state.errorInfo.componentStack}
                    </textarea>
                </details>
            </div>
          </div>
        </div>
        );
      }
      // Normally, just render children
      return this.props.children;
    }  
}

export default ErrorBoundary;